import React, { useEffect, useState } from "react";
import {
  Grid,
  Tooltip,
  Card,
} from "@mui/material";
import {
  Info as InfoIcon,
  Store as StoreIcon,
  PhotoLibrary as PhotoLibraryIcon,
  Description as DescriptionIcon,
  LocationOn as LocationOnIcon,
  AccessTime as AccessTimeIcon,
  Star as StarIcon,
  ArrowCircleRightOutlined,
} from "@mui/icons-material";
import GeneralInformation from "./components/General";
import SimpleForm from "./components/MerchantSetting";
import ImageGallery from "./components/GalleryImage";
import HoursOfOperation from "./components/OperationHours";
import AdditionalLocation from "./components/Address";
import TermsAndConditions from "./components/Terms&Condition";
import HighlightsComponent from "./components/Highlights";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import { baseURL } from "utils/api";
import AccountCircleIcon from '@mui/icons-material/Preview';
import Profile from "./components/profile";
import { Link, useParams } from "react-router-dom";
import HappyHours from "./components/HappyHours";
import useMediaQuery from '@mui/material/useMediaQuery';
import DummyImage from "assets/images/2665820.jpg";
import { useSelector } from "react-redux";


const BusinessForm = () => {
  
  const matches = useMediaQuery('(max-width:600px)');
  const [logo1, setLogo1] = useState(null);
  const { id } = useParams()
  const [activeSection, setActiveSection] = useState("Preview");
  const adminId = localStorage.getItem("id");
  const [refresh, setRefresh] = useState(0)
  const [profileFile, setProfileFile] = useState(null);
  const [businessDetail, setBusinessDetail] = useState({});

 const userTheme = useSelector((state) => state.commonSlice.theme);
  const handleLogoUpload = (event, setLogo) => {
    const file = event.target.files[0];
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setLogo(fileURL);
      setProfileFile(file);
    }

    const formData = new FormData();
    formData.append("profileImage", file);
    fetch(`${baseURL}/profile/updateProfile2/${businessDetail?._id}`, {
      method: "POST",
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((resp) => {
        if (resp.status == 200) {
        window.location.reload();
        }
      });

  };

  const triggerFileUpload = (inputId) => {
    document.getElementById(inputId).click();
  };

  const handleSectionClick = (section) => {
    setActiveSection(section);
  };


  const [sections, setSections] = useState([
    { label: "Preview", icon: AccountCircleIcon },
    { label: "General Information", icon: InfoIcon },
    { label: "Merchant Settings", icon: StoreIcon },
    { label: "Image Gallery", icon: PhotoLibraryIcon },
    { label: "Hours Of Operation", icon: AccessTimeIcon },
    { label: "Terms and Conditions", icon: DescriptionIcon },
    { label: "Highlights", icon: StarIcon },
  ])



  const fetchBusinessDetail = async () => {
    fetch(`${baseURL}/profile/getBusinessDetailsById/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => res.json())
      .then((resp) => {
        if (resp.status == 200) {
          setBusinessDetail(resp.data);

          if (resp.data?.category?.name == 'Dining & Drinks') {
            setSections([
              { label: "Preview", icon: AccountCircleIcon },
              { label: "General Information", icon: InfoIcon },
              { label: "Merchant Settings", icon: StoreIcon },
              { label: "Image Gallery", icon: PhotoLibraryIcon },
              { label: "Hours Of Operation", icon: AccessTimeIcon },
              { label: "Terms and Conditions", icon: DescriptionIcon },
              { label: "Highlights", icon: StarIcon },
              { label: "Happy Hours Config", icon: AccessTimeIcon }
            ])
          }
        } 
      });
  };

  useEffect(() => {
    fetchBusinessDetail()
  }, [refresh]);


  const handelRefresh = () => {
    setRefresh(refresh + 1)
  }


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={3}>
        {/* Sidebar */}
        <Grid item xs={12} sm={3} sx={{ position: matches ? 'static' : 'sticky', top: 0, height: 'fit-content' }}>
          <Card className="glassmorphism-card" elevation={3} style={{ padding: 20, textAlign: "center" }}>
            <SoftBox style={{ position: "relative", display: "inline-block" }}>
              <SoftBox
                variant="outlined"
                color="info"
                style={{ position: "absolute", top: -13, left: -10, cursor: "pointer" }}
              >
                <Link to="/business-Profile">
                  <ArrowCircleRightOutlined
                    style={{ transform: "rotate(180deg)", color:userTheme=='dark'? "#ffffff":"#141414" }}
                  />
                </Link>
              </SoftBox>

              <SoftBox p={1}>
                <Tooltip title="Edit Logo">
                  <img
                    src={(logo1 == null && businessDetail?.profileImage!='')? businessDetail?.profileImage : DummyImage}
                    alt="Restaurant Logo 1"
                    onClick={() => triggerFileUpload("logo-upload-1")}
                    style={{ width: "100%", maxWidth: 100, height: 100, borderRadius: "50%", border: "1px solid #ccc", cursor: "pointer" }}
                  />
                </Tooltip>
              </SoftBox>

              <input
                id="logo-upload-1"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={(e) => handleLogoUpload(e, setLogo1)}
              />
            </SoftBox>
            <SoftTypography
              variant="h5"
              gutterBottom
              style={{
                fontWeight: "bold",
              }}
            >
              {businessDetail?.firstName}
            </SoftTypography>
          </Card>
          <SoftBox mt={3}
            style={{ padding: 20, textAlign: "center" }}
            className="glassmorphism-card"
          >
            {sections.map(({ label, icon: Icon }) => (
              <SoftTypography
                key={label}
                variant="h6"
                gutterBottom
                style={{
                  borderBottom: "1px solid gainsboro",
                  padding: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                  color: activeSection === label ? "skyblue" : "",
                }}
                onClick={() => handleSectionClick(label)}
              >
                <Icon
                  style={{
                    fontSize: "5.5rem",
                    color: activeSection === label ? "skyblue" : "",
                  }}
                />
                {label}
              </SoftTypography>
            ))}
          </SoftBox>

        </Grid>


        <Grid item xs={12} sm={9}>
          
          {activeSection === "Preview" && <Profile data={businessDetail} />}
          {activeSection === "General Information" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><GeneralInformation data={businessDetail} profile={profileFile}  handelRefresh={handelRefresh}  /></Card>}
          {activeSection === "Merchant Settings" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><SimpleForm data={businessDetail} handelRefresh={handelRefresh} /></Card>}
          {activeSection === "Image Gallery" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><ImageGallery refresh={refresh} data={businessDetail?.images} id={businessDetail?._id} handelRefresh={handelRefresh} /></Card>}
          {activeSection === "Hours Of Operation" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><HoursOfOperation data={businessDetail?.operatingHours} id={businessDetail?._id} /></Card>}
          {activeSection === "Happy Hours Config" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><HappyHours id={businessDetail?._id} handelRefresh={handelRefresh} /></Card>}
          {activeSection === "Terms and Conditions" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><TermsAndConditions data={businessDetail?.termsAndConditions} id={businessDetail?._id} handelRefresh={handelRefresh} /></Card>}
          {activeSection === "Highlights" && <Card elevation={3} style={{ padding: matches ? 2 : 20 }} className="glassmorphism-card" ><HighlightsComponent email={businessDetail?.email} id={businessDetail?._id} userId={businessDetail?.userId}/></Card>}

        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default BusinessForm;










